import React, { useState } from "react"
import { Button } from "reactstrap"

const OrderDetailItem = ({
  orderDetail,
  orderDetails,
  writeData,
  collectionName,
  readOnly,
  isAssistant
}) => {
  const [isDeleted, setIsDeleted] = useState(false)

  if (isDeleted) {
    return null
  }

  return (
    <div className="product-item">
      <div className="column-value image-block">
        <div
          className="img"
          style={{
            backgroundImage: orderDetail.product.photoUrl
              ? `url(http://${orderDetail.product.photoUrl})`
              : "url(http://bit.ly/28Y6Apr)"
          }}
        />
      </div>
      <div className="info-block">
        <div className="column-value price">
          <label>品名</label>
          {orderDetail.product.name}
        </div>
        <div className="column-value price">
          <label>售價</label>
          {isAssistant ? (
            <input
              type="text"
              pattern="[0-9]*"
              className="form-control"
              value={orderDetail.unitPrice || ""}
              onChange={e => {
                if (!e.target.validity.valid) {
                  return
                }
                writeData(
                  collectionName,
                  orderDetails.map(o => {
                    return o.id === orderDetail.id
                      ? { ...o, unitPrice: Number(e.target.value) }
                      : o
                  })
                )
              }}
              disabled={readOnly}
            />
          ) : (
            orderDetail.unitPrice || "待業務議價"
          )}
        </div>
        <div className="column-value quantity">
          <label>數量</label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => {
                  writeData(
                    collectionName,
                    orderDetails.map(o => {
                      return o.id === orderDetail.id
                        ? { ...o, quantity: o.quantity - 1 }
                        : o
                    })
                  )
                }}
                disabled={readOnly || orderDetail.quantity <= 0}
              >
                <i className="fas fa-minus" />
              </button>
            </div>
            <input
              type="text"
              pattern="[0-9]*"
              className="form-control"
              value={orderDetail.quantity}
              onChange={e => {
                if (!e.target.validity.valid) {
                  return
                }

                writeData(
                  collectionName,
                  orderDetails.map(o => {
                    return o.id === orderDetail.id
                      ? { ...o, quantity: Number(e.target.value) }
                      : o
                  })
                )
              }}
              disabled={readOnly}
            />
            <div className="input-group-prepend">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => {
                  writeData(
                    collectionName,
                    orderDetails.map(o => {
                      return o.id === orderDetail.id
                        ? { ...o, quantity: o.quantity + 1 }
                        : o
                    })
                  )
                }}
                disabled={readOnly}
              >
                <i className="fas fa-plus" />
              </button>
            </div>
          </div>
        </div>
        <div className="column-value subtotal mt-2">
          <label>小計</label>

          {orderDetail.unitPrice
            ? `NT$ ${(
                orderDetail.unitPrice * orderDetail.quantity
              ).toLocaleString()}`
            : "待業務報價"}
        </div>

        <div className="column-value delete">
          <Button
            color="secondary"
            outline
            onClick={() => {
              writeData(
                collectionName,
                orderDetails.map(o => {
                  return o.id === orderDetail.id ? { ...o, quantity: 0 } : o
                })
              )

              setIsDeleted(true)
            }}
            disabled={readOnly}
          >
            <i className="far fa-trash-alt" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default OrderDetailItem
